export default "__VITE_ASSET__DvrjHCCk__"